import React from "react";
import { connect } from "react-redux";
import { List } from "devextreme-react";
import LoadingOverlay from "../../../../../Shared/LoadingOverlay";


class Baterias extends React.PureComponent {
  render() {
    const baterias = this.props.dataSelected && this.props.dataSelected.Pools ? [{ key: `Baterías (${this.props.dataSelected.Pools.length})`, items: this.props.dataSelected.Pools.map((e) => e.Description) }] : [];
    const examenes = this.props.dataSelected && this.props.dataSelected.AdditionalExams ? [{ key: `Prestaciones médicas (${this.props.dataSelected.AdditionalExams.length})`, items: this.props.dataSelected.AdditionalExams.map((e) => e.Description) }] : [];
    const psicologicos = this.props.dataSelected && this.props.dataSelected.PsychologicalExams ? [{ key: `Evaluaciones psicológicas (${this.props.dataSelected.PsychologicalExams.length})`, items: this.props.dataSelected.PsychologicalExams.map((e) => e.Description) }] : [];
    const _lista = [...baterias, ...examenes, ...psicologicos];
    return (
      <div className="row" >
        <div className="col-12" >
          {this.props.isLoading && <LoadingOverlay />}
          <div className="headNotificaction-flex" >
            <div className="headNotificaction" ></div>
          </div>
          <List
            className="listPoolsExams"
            dataSource={_lista}
            height="100%"
            grouped
            collapsibleGroups
            focusStateEnabled={false}
            scrollingEnabled
            hoverStateEnabled={false}
            groupRender={(item) =>
              <div>{item.key}</div>
            }
            onContentReady={(c) => {
              for (let i = 0; i < _lista.length; i++) { c.component.collapseGroup(i); }
            }}
          />
        </div>
      </div >
    );
  }
}

const mapStateToProps = (state) => ({
  isLoading: state.confirmacionSolicitudesAgendaSel.isLoading,
  dataSelected: state.confirmacionSolicitudesAgendaSel.dataSelected,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(Baterias);
